import type { DocumentVersionSummary } from "~/api/types";
import type { UpdateDocumentData } from "~/api/v2/requests";
import { DocumentVersionStatus } from "~/config/types";
import type {
  DocumentEditableField,
  EditableField,
  VersionEditableField,
} from "./libraryTypes";

export const isVersionEditableField = (
  field: EditableField,
): field is VersionEditableField =>
  field === "reviewFrom" || field === "reviewTo" || field === "adoptedAt";

export const isEditableField = (
  documentVersion: DocumentVersionSummary,
  field: EditableField | undefined,
): boolean => {
  if (field === undefined) return false;
  if (!isVersionEditableField(field)) return true;

  if (field === "adoptedAt") {
    return (
      documentVersion.status === DocumentVersionStatus.draft ||
      documentVersion.status === DocumentVersionStatus.published
    );
  }

  return documentVersion.status === DocumentVersionStatus.draft;
};

const payloadKeysByEditableField: Record<
  DocumentEditableField,
  (keyof UpdateDocumentData)[]
> = {
  categoryId: ["categoryId", "linkedDocumentIds"],
  tierId: ["tierId", "linkedDocumentIds"],
  referenceNumber: ["referenceNumber"],
  ownerId: ["ownerId"],
  publisherId: ["publisherId"],
  tags: ["tagIds"],
  links: ["linkedDocumentIds"],
};

export const getPayloadForField = (
  field: DocumentEditableField,
  payload: UpdateDocumentData,
): UpdateDocumentData =>
  Object.fromEntries(
    Object.entries(payload).filter(([key]) =>
      payloadKeysByEditableField[field].includes(
        key as keyof UpdateDocumentData,
      ),
    ),
  ) as UpdateDocumentData;
